import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';
import { serializeCustomerOrderUpdate } from './serialize';

/** PATCH `/crm/customer-order/{id}`。僅 DRAFT；body 含 updatedAt（record）。 */
export async function updateCustomerOrder(id, payload) {
  const { data: raw } = await request.patch(
    `/crm/customer-order/${id}`,
    serializeCustomerOrderUpdate(payload),
  );
  return parseVer4DetailResponse(raw);
}
